import React from 'react';
import { useTranslation } from 'react-i18next';
import HeaderActionButton from './HeaderActionButton';

/**
 * Cartouche Playbooks harmonisé avec le système unifié (comme DMBTTrigger)
 */
const PlaybooksTrigger = ({ onClick }) => {
  const { t } = useTranslation('playbooks');
  return (
    <HeaderActionButton 
      onClick={onClick}
      gradient="blue"
      className="playbooks-trigger"
    >
      <div className="button-header">
        <div className="button-icon">📚</div>
        <div className="button-text-content">
          <h3 className="button-title">{t('playbooksTrigger.title')}</h3>
          <p className="button-subtitle">{t('playbooksTrigger.subtitle')}</p>
        </div>
  <span className="button-badge">{t('playbooksTrigger.badge')}</span>
      </div>

      <div className="button-features">
        <div className="button-feature">
          <span>🧑‍💻</span>
          <span>{t('playbooksTrigger.concepts.collaboration')}</span>
        </div>
        <div className="button-feature">
          <span>🔒</span>
          <span>{t('playbooksTrigger.concepts.security')}</span>
        </div>
        <div className="button-feature">
          <span>📈</span>
          <span>{t('playbooksTrigger.concepts.analysis')}</span>
        </div>
      </div>

      <div className="button-cta playbooks-trigger-cta">
        <span className="button-cta-text">
          <span className="cta-icon" style={{ marginRight: '8px', fontSize: '1.1em' }}>📚✨</span>
          {t('playbooksTrigger.buttonText')}
        </span>
      </div>
    </HeaderActionButton>
  );
};

export default PlaybooksTrigger;
